import RouteAppShell from '@/common/components/app-shell/RouteAppShell.tsx';
import AdminSidebar from '@/features/admin/components/AdminSidebar.tsx';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  component: RouteComponent,
  staticData: {
    authorization: {
      role: 'admin',
    },
  },
});

function RouteComponent() {
  return (
    <RouteAppShell sidebar={{ children: <AdminSidebar /> }}>
      <Outlet />
    </RouteAppShell>
  );
}
